import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import style from "./FaqAccordion.module.css";
import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";
import { buildFaq } from "@/features/landing/faqData";
import { useFreeCourses } from "@/features/courses/hooks/useFreeCourses";

function FaqAccordion() {
	const { t } = useTranslation();
	const [open, setOpen] = useState(0);
	const { freeOffer } = useFreeCourses();
	// `t` changes with the language, so the questions follow a switch.
	const faq = useMemo(() => buildFaq(t, freeOffer), [t, freeOffer]);

	return (
		<div>
			<h2 className={style.title}>{t("landing:faq.title")}</h2>

			<div className={style.list}>
				{faq.map((item, index) => {
					const isOpen = open === index;
					return (
						<div key={item.q} className={style.item}>
							<button
								type="button"
								id={`faq-q-${index}`}
								className={style.trigger}
								aria-expanded={isOpen}
								aria-controls={`faq-a-${index}`}
								onClick={() => setOpen(isOpen ? -1 : index)}
							>
								<span className={style.q}>{item.q}</span>
								<span
									className={`${style.mark} ${
										isOpen ? style.markOn : ""
									}`}
								>
									<Icon
										icon={isOpen ? "fa-minus" : "fa-plus"}
									/>
								</span>
							</button>
							{isOpen && (
								<p
									id={`faq-a-${index}`}
									role="region"
									aria-labelledby={`faq-q-${index}`}
									className={style.a}
								>
									{item.a}
								</p>
							)}
						</div>
					);
				})}
			</div>

			<Button type="outline" className={style.help} to="/support">
				<span>{t("landing:faq.more")}</span>
				<Icon icon="fa-envelope" />
			</Button>
		</div>
	);
}

export default FaqAccordion;
